module.exports = __webpack_public_path__ + "img/03.3c953db1.png";